import { declareString } from "@1js/localization";

export const SeeAll = declareString("promptLibrary.seeAll", {
  text: "See all",
  comment:
    "Text which appears on the bookmarked prompts tab for the see all prompts button.",
});

export const SeeAllYourPrompts = declareString(
  "promptLibrary.seeAllYourPrompts",
  {
    text: "See all your prompts",
    comment:
      "Text which appears on the bookmarked prompts tab for the See all your prompts button.",
  }
);
